import type { FC } from "react";
import { useMemo } from "react";
import { useCustomTemplates } from "../../pages/create-content/use-custom-templates";
import { useMultiformat } from "../multiformat/hooks/use-multi-format";
import { useGenerateCommsContext } from "../template-preview/generate-comms-context";
import { CommsCustomStyleSelect } from "./comms-custom-style-select";
import { ImageShapeSelect } from "./image-shape-select";
import { VisualStyleSelect } from "./visual-style-select";

// TODO: lots of code duplication with ImageStyle
// just pass the props through and share this component
export const CommsImageStyle: FC = () => {
  const { data: multiformat } = useMultiformat();
  const customTemplatesLoader = useCustomTemplates(multiformat);
  const {
    branding: { selectedStyle, selectedImageType, setBrandingStyle, setBrandingImageType },
  } = useGenerateCommsContext();

  const hasCustomTemplates = useMemo(() => {
    if (customTemplatesLoader.loading) return false;

    const squares = customTemplatesLoader.data?.["Square Comms"] ?? [];
    const banners = customTemplatesLoader.data?.["Landscape Comms"] ?? [];

    return squares.length > 0 || banners.length > 0;
  }, [customTemplatesLoader]);

  if (customTemplatesLoader.loading) return null;

  return (
    selectedStyle && (
      <>
        {hasCustomTemplates ? (
          <CommsCustomStyleSelect
            data-testid="custom-style-select"
            customTemplates={customTemplatesLoader.data!}
          />
        ) : (
          <>
            <VisualStyleSelect
              onChange={setBrandingStyle}
              brandStyle={selectedStyle?.branding_type}
              data-testid="visual-style-select"
            />
            <ImageShapeSelect
              onChange={setBrandingImageType}
              imageType={selectedImageType}
              data-testid="image-type-select"
            />
          </>
        )}
      </>
    )
  );
};
